export { default } from './AddMediaThumbnail';
